import React from "react";
import { Container, Heading, SubHeading,Text} from "./styles/testimonial";

export default function Testimonial({ children, ...restProps }) {
  return <Container {...restProps}> {children} </Container>;
}

Testimonial.Heading = function TestimonialHeading({ children, ...restProps }) {
  return <Heading {...restProps}>{children}</Heading>;
};

Testimonial.SubHeading = function TestimonialSubHeading({ children, ...restProps }) {
  return <SubHeading {...restProps}>{children}</SubHeading>;
};

Testimonial.Text = function TestimonialText({children, ...restProps}){
    return <Text {...restProps}>{children}</Text>
  }